import Vue from 'vue'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import has from 'lodash/has'

/* Prototype of this Store */
const proto = {
  uuid: null,
  name: null,
  fullInfoLoaded: false
}
/* End Prototype of this Store */

export const state = () => {}

export const getters = {
  all (state) {
    return state
  },
  has: (state) => (uuid) => {
    return has(state, uuid)
  },
  get: (state, getters) => (uuid) => {
    if (getters.has(uuid)) {
      return state[uuid]
    }
  },
  getByUsername: (state, getters) => (username) => {
    return find(state, { username })
  },
  getList: (state, getters) => (uuids) => {
    return uuids.map(uuid => {
      return getters.get(uuid)
    })
  }
}

export const mutations = {
  add (state, data) {
    let items = data
    if (!(data instanceof Array)) {
      items = [ data ]
    }

    items.map(user => {
      let original = has(state, user.uuid) ? state[user.uuid] : proto
      let item = {
        ...original,
        ...user
      }
      Vue.set(state, user.uuid, item)
    })
  },
  toggleFollow (state, uuid) {
    let value = !state[uuid].followed_by_user
    state[uuid].followed_by_user = value

    // Increment or decrement the like
    if (value) {
      state[uuid].followers_count++
    } else {
      state[uuid].followers_count--
    }
  },
  addTeamMember (state, { uuid, member, members }) {
    let team = state[uuid]

    if (team) {
      // Create Members object if not exists
      if (!team.members) {
        team.members = []
      }

      if (member) {
        team.members.push(member)
      } else {
        team.members = [
          ...team.members,
          ...members
        ]
      }
    }
  },
  removeTeamMember (state, { uuid, member }) {
    let team = state[uuid]

    if (team) {
      let index = findIndex(team.members, (m) => m.uuid === member.uuid)
      team.members.splice(index, 1)
    }
  },
  updateTeamMember (state, { uuid, member }) {
    let team = state[uuid]

    if (team) {
      team.members[team.members.indexOf(member)] = member
    }
  }
}
